export default __webpack_public_path__ + "static/media/logo2021.2f1354e2.png";